import React, {useEffect, useRef} from 'react';
import {useParams, useHistory} from 'react-router';
import {Container} from 'react-bootstrap';

import ContactInvitePage from 'components/pages/ContactInvitePage/ContactInvitePage';
import {HashParamType} from 'types/common';
import {PATH} from 'constants/common';
import {
    InviteType,
    useResolveInviteStore,
} from 'components/pages/ResolveInvitePage/resolveInviteStore';
import BusinessPartnerInvitePage from './BusinessPartnerInvitePage';

interface IResolveInvitePageProps {
    authorized?: boolean;
    type: InviteType;
}

const ResolveInvitePage: React.FC<IResolveInvitePageProps> = ({
    authorized = false,
    type,
}) => {
    const setInvite = useResolveInviteStore(state => state.setInvite);
    const history = useHistory();
    const {hash} = useParams<HashParamType>();
    const setStoreRef = useRef<boolean>(false);

    useEffect(() => {
        if (!setStoreRef.current) {
            setInvite({
                hash,
                type,
            });

            setStoreRef.current = true;
        }

        if (!authorized) {
            history.push(PATH.REGISTRATION);
        }
    }, [authorized, hash, history, setInvite, type]);

    if (!authorized) {
        return null;
    }

    return (
        <Container fluid>
            {type === 'business-partner' ? (
                <BusinessPartnerInvitePage />
            ) : (
                <ContactInvitePage />
            )}
        </Container>
    );
};

export default ResolveInvitePage;
